import { searchAdapter, searchContentAdapter, SearchResultResponse, SearchContentResponse } from 'application/adapters/search/searchAdapter';

export const getSearchResults = (query: string, page: number, sorting: string, locale: string): Promise<SearchResultResponse> => {
	return searchAdapter({ query, page, sorting, locale });
};

export const getSearchContent = async (language: string = 'en', query: string): Promise<SearchContentResponse> => {
	return await searchContentAdapter(language, query);
};
